export default function LegitSection() {
  return (
    <section id="legit" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="lg:w-1/2">
            <div className="w-full h-64 md:h-80 rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20reassuring%20security%20concept%20with%20a%20transparent%20glass%20lock%20symbol%20on%20a%20minimal%20light%20desk%2C%20soft%20sand%20and%20cream%20color%20palette%2C%20natural%20daylight%20through%20sheer%20curtains%2C%20calm%20trustworthy%20aesthetic%2C%20editorial%20photography%2C%20clean%20professional%20composition%2C%20reassuring%20atmosphere&width=800&height=600&seq=legit-main-v3&orientation=landscape"
                alt="Is Sugargoo Legit - Trust and safety verification for international shopping platform"
                title="Sugargoo Legitimacy and Trust Analysis"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
          </div>

          <div className="lg:w-1/2">
            <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-wider mb-3 bg-accent-100 px-3 py-1 rounded-full">
              Trust & Safety
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              Is Sugargoo Legit? <span className="text-primary-500">What You Need to Know</span>
            </h2>

            <div className="space-y-4 mb-6">
              <div className="flex gap-3">
                <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mt-0.5">
                  <i className="ri-building-4-line"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900 mb-1">Established Company</h4>
                  <p className="text-sm text-foreground-600 leading-relaxed">Sugargoo has been operating for years with a proven track record in the international shopping agent industry, serving thousands of customers worldwide.</p>
                </div>
              </div>
              <div className="flex gap-3">
                <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mt-0.5">
                  <i className="ri-archive-line"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900 mb-1">Professional Warehouse System</h4>
                  <p className="text-sm text-foreground-600 leading-relaxed">Fully equipped warehouses with quality inspection services, secure storage, and professional packaging ensure your items are handled with care.</p>
                </div>
              </div>
              <div className="flex gap-3">
                <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mt-0.5">
                  <i className="ri-secure-payment-line"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900 mb-1">Secure Payments</h4>
                  <p className="text-sm text-foreground-600 leading-relaxed">Multiple secure payment methods are available with standard buyer protections in place for all transactions.</p>
                </div>
              </div>
            </div>

            <div className="p-4 bg-secondary-100/70 rounded-lg border border-secondary-200/50">
              <p className="text-xs text-foreground-500 italic leading-relaxed">
                <strong className="text-foreground-700 not-italic">Disclaimer:</strong> This website is an independent educational resource created to help international shoppers make informed decisions. We are not officially affiliated with, endorsed by, or connected to Sugargoo in any way.
              </p>
            </div>

            <a
              href="/article/is-sugargoo-legit-safe"
              className="inline-flex items-center gap-2 mt-4 text-sm font-semibold text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Read full trust & safety analysis
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}